import { Box, Container, Typography, Button } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import LocalOfferIcon from "@mui/icons-material/LocalOffer";

import pricingHeroBg from "../../assets/images/pricing_hero_bg.png";
import pricingHeroBgm from "../../assets/images/pricing_hero_bg_m.png";

export default function PricingHero() {
  return (
    <Box
      sx={{
        position: "relative",

        overflow: "hidden",

        py: {
          xs: 4,
          md: 6,
        },

        backgroundImage: {
          xs: `url(${pricingHeroBgm})`,
          md: `url(${pricingHeroBg})`,
        },

        backgroundSize: "cover",

        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="xl">
        <Box
          sx={{
            display: "flex",

            flexDirection: {
              xs: "column",
              lg: "row",
            },

            alignItems: "center",

            justifyContent: "space-between",

            gap: {
              xs: 5,
              md: 8,
            },
          }}
        >
          {/* LEFT CONTENT */}

          <Box
            sx={{
              flex: 1,

              textAlign: {
                xs: "center",
                lg: "left",
              },
            }}
          >
            <Box
              sx={{
                display: "inline-flex",

                px: 2.5,

                py: 1,

                borderRadius: "50px",

                background: "rgba(0,87,255,.08)",

                color: "#0057FF",

                fontSize: "12px",

                fontWeight: 800,

                letterSpacing: "1px",

                textTransform: "uppercase",
              }}
            >
              <LocalOfferIcon
                sx={{
                  color: "#0057FF",

                  fontSize: 18,
                }}
              />

              <Typography
                sx={{
                  fontWeight: 800,

                  color: "#0057FF",

                  fontSize: "12px",

                  letterSpacing: "1px",

                  textTransform: "uppercase",
                }}
              >
                Transparent Pricing
              </Typography>
            </Box>

            <Typography
              sx={{
                mt: 3,

                fontWeight: 900,

                lineHeight: 1.05,

                color: "#07122F",

                fontSize: {
                  xs: "32px",
                  sm: "32px",
                  md: "56px",
                  lg: "56px",
                },
                display: "block",
              }}
            >
              Premium Care.{" "}
              <Box
                component="span"
                sx={{
                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  WebkitBackgroundClip: "text",

                  WebkitTextFillColor: "transparent",
                }}
              >
                Fair Pricing.
              </Box>
            </Typography>

            <Typography
              sx={{
                mt: 3,

                maxWidth: "650px",

                mx: {
                  xs: "auto",
                  lg: 0,
                },

                color: "#64748B",

                lineHeight: 1.8,

                fontSize: {
                  xs: "13px",
                  sm: "14px",
                  md: "16px",
                },
              }}
            >
              No hidden fees. No surprises. Professional cleaning, alterations,
              shoe care, custom printing and specialty services delivered with
              transparent and competitive pricing.
            </Typography>

            {/* BUTTONS */}

            <Box
              sx={{
                mt: 4,

                display: "flex",

                justifyContent: {
                  xs: "center",
                  lg: "flex-start",
                },

                gap: 1.5,

                flexWrap: "nowrap",
              }}
            >
              <Button
                endIcon={<ArrowForwardIcon />}
                sx={{
                  minWidth: {
                    xs: 150,
                    md: 190,
                  },

                  height: {
                    xs: 46,
                    md: 54,
                  },

                  borderRadius: "50px",

                  background: "linear-gradient(135deg,#0057FF,#1DB6FF)",

                  color: "#fff",

                  fontWeight: 800,

                  textTransform: "none",

                  fontSize: {
                    xs: "13px",
                    md: "15px",
                  },

                  boxShadow: "0 15px 35px rgba(0,87,255,.20)",

                  "&:hover": {
                    background: "linear-gradient(135deg,#0057FF,#1DB6FF)",
                  },
                }}
              >
                View Pricing
              </Button>

              <Button
                startIcon={<WhatsAppIcon />}
                href="https://wa.me/+19054283542"
                target="_blank"
                component="a"
                sx={{
                  minWidth: {
                    xs: 150,
                    md: 190,
                  },

                  height: {
                    xs: 46,
                    md: 54,
                  },

                  borderRadius: "50px",

                  border: "2px solid rgba(37,211,102,.35)",

                  background: "rgba(37,211,102,.08)",

                  color: "#25D366",

                  fontWeight: 800,

                  textTransform: "none",

                  fontSize: {
                    xs: "13px",
                    md: "15px",
                  },

                  "&:hover": {
                    background: "rgba(37,211,102,.12)",
                  },
                }}
              >
                WhatsApp Us
              </Button>
            </Box>

            {/* STATS */}

            <Box
              sx={{
                mt: 5,

                display: "flex",

                justifyContent: {
                  xs: "center",
                  lg: "flex-start",
                },

                gap: {
                  xs: 3,
                  md: 5,
                },
              }}
            >
              {[
                {
                  number: "1000+",
                  label: "Happy Customers",
                },

                {
                  number: "12+",
                  label: "Expert Services",
                },

                {
                  number: "10+",
                  label: "Service Areas",
                },
              ].map((item, index) => (
                <Box key={index}>
                  <Typography
                    sx={{
                      fontWeight: 900,

                      color: "#0057FF",

                      fontSize: {
                        xs: "34px",
                        md: "54px",
                      },
                    }}
                  >
                    {item.number}
                  </Typography>

                  <Typography
                    sx={{
                      color: "#64748B",

                      fontWeight: 600,
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>

          {/* RIGHT SIDE */}

          <Box
            sx={{
              flex: 1,

              display: {
                xs: "none",
                lg: "flex",
              },

              justifyContent: "center",

              position: "relative",
            }}
          >
            {/* <Box
              sx={{
                width: 500,

                height: 500,

                borderRadius: "40px",

                backdropFilter: "blur(20px)",

                background: "rgba(255,255,255,.35)",

                border: "1px solid rgba(255,255,255,.7)",

                boxShadow: "0 30px 80px rgba(0,87,255,.08)",
              }}
            /> */}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}